export interface Category {
  slug: string;
  name: string;
  cover: string;
  description: string;
  color: string;
}

export const categories: Category[] = [
  {
    slug: "guoman",
    name: "国漫",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20chinese%20wuxia%20anime%20key%20visual%20of%20a%20swordswoman%20in%20flowing%20robes%20with%20ink%20wash%20background%2C%20warm%20vermilion%20and%20gold%20palette%2C%20dramatic%20lighting%2C%20detailed%20illustration&width=600&height=800&seq=cat-guoman&orientation=portrait",
    description: "本土原创动画，东方美学与热血叙事",
    color: "#c94b2f",
  },
  {
    slug: "riman",
    name: "日漫",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20japanese%20anime%20key%20visual%20of%20a%20teen%20hero%20with%20wind%20and%20floating%20particles%2C%20warm%20orange%20twilight%20palette%2C%20cinematic%20sky%2C%20clean%20background%2C%20detailed%20cel%20shading&width=600&height=800&seq=cat-riman&orientation=portrait",
    description: "经典日系动画，热血、恋爱与幻想",
    color: "#d98324",
  },
  {
    slug: "xinfan",
    name: "新番",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20seasonal%20new%20series%20banner%20with%20sparkling%20stars%20and%20shooting%20comets%2C%20energetic%20youth%20characters%2C%20warm%20gold%20and%20coral%20palette%2C%20vibrant%20composition&width=600&height=800&seq=cat-xinfan&orientation=portrait",
    description: "每季最新番剧抢先看，追更不落空",
    color: "#e2a03b",
  },
  {
    slug: "rexue",
    name: "热血",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20fighting%20action%20key%20visual%20with%20energy%20flames%20and%20dynamic%20pose%2C%20warm%20red%20and%20orange%20palette%2C%20dark%20background%2C%20high%20contrast%20cinematic%20illustration&width=600&height=800&seq=cat-rexue&orientation=portrait",
    description: "燃烧斗志，为梦想与羁绊而战",
    color: "#c0442b",
  },
  {
    slug: "lianai",
    name: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20romance%20anime%20key%20visual%20of%20two%20characters%20under%20cherry%20blossom%20rain%2C%20soft%20pink%20and%20warm%20amber%20palette%2C%20gentle%20bokeh%20background%2C%20sweet%20atmosphere&width=600&height=800&seq=cat-lianai&orientation=portrait",
    description: "青涩心动，怦然再遇的青春物语",
    color: "#d85f6a",
  },
  {
    slug: "gaoxiao",
    name: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20comedy%20anime%20key%20visual%20with%20playful%20chibi%20characters%20and%20confetti%2C%20bright%20yellow%20and%20coral%20palette%2C%20cheerful%20flat%20illustration%20style&width=600&height=800&seq=cat-gaoxiao&orientation=portrait",
    description: "轻松解压，笑点密集的欢乐日常",
    color: "#e0a832",
  },
  {
    slug: "qihuan",
    name: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20fantasy%20anime%20key%20visual%20with%20magical%20gateway%20and%20glowing%20runes%2C%20warm%20amethyst%20and%20gold%20palette%2C%20mystical%20atmosphere%2C%20epic%20landscape&width=600&height=800&seq=cat-qihuan&orientation=portrait",
    description: "异世界冒险，想象力的无限边界",
    color: "#8a5a2b",
  },
  {
    slug: "yundong",
    name: "运动",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20sports%20anime%20key%20visual%20of%20a%20basketball%20player%20in%20action%20under%20court%20lights%2C%20warm%20orange%20and%20amber%20palette%2C%20dynamic%20motion%2C%20energetic%20composition&width=600&height=800&seq=cat-yundong&orientation=portrait",
    description: "汗水与荣耀，竞技场上的青春",
    color: "#d9781f",
  },
  {
    slug: "zhiyu",
    name: "治愈",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20slice%20of%20life%20anime%20key%20visual%20with%20cozy%20cafe%20interior%20and%20warm%20lamplight%2C%20soft%20cream%20and%20amber%20palette%2C%20gentle%20daylight%2C%20relaxing%20atmosphere&width=600&height=800&seq=cat-zhiyu&orientation=portrait",
    description: "温柔日常，治愈疲惫的慢生活",
    color: "#d99a4e",
  },
  {
    slug: "xuanyi",
    name: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20mystery%20anime%20key%20visual%20with%20noir%20detective%20silhouette%20and%20city%20neon%20at%20night%2C%20deep%20maroon%20and%20amber%20palette%2C%20shadowy%20moody%20composition&width=600&height=800&seq=cat-xuanyi&orientation=portrait",
    description: "层层谜团，真相隐藏在暗处",
    color: "#6e4a2e",
  },
];